"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var reportsApi_1 = require("../mock/reportsApi");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var reportsApi = {
    getReports: function (token, options) { return __awaiter(void 0, void 0, void 0, function () {
        var search, offset, limit, source, fromDate, toDate, sort, sourceString, queryParams, params, url;
        return __generator(this, function (_a) {
            search = options.search, offset = options.offset, limit = options.limit, source = options.source, fromDate = options.fromDate, toDate = options.toDate, sort = options.sort;
            sourceString = source === null || source === void 0 ? void 0 : source.toString();
            queryParams = new URLSearchParams(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (search !== undefined && { search: search })), (offset !== undefined && { offset: String(offset) })), (limit !== undefined && { limit: String(limit) })), (sourceString && { source: sourceString })), (fromDate !== undefined && { fromDate: fromDate })), (toDate !== undefined && { toDate: toDate })), (sort !== undefined && { sort: sort })));
            params = queryParams.toString();
            url = "".concat(coreServiceUrl, "/reports").concat(params ? "?".concat(params) : '');
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return (0, reportsApi_1.mockGetReports)(); },
                    url: url,
                    token: token,
                })];
        });
    }); },
    getReportsStatus: function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            url = "".concat(coreServiceUrl, "/reports/status");
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return reportsApi_1.mockGetReportStatus; },
                    url: url,
                    token: token,
                })];
        });
    }); },
    updateReportName: function (token, uuid, name) { return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            url = "".concat(coreServiceUrl, "/reports/update-name/").concat(uuid);
            return [2 /*return*/, rest_1.default.put({
                    mockFunc: function () { return ({ success: true, updatedName: name }); },
                    url: url,
                    body: {
                        newName: name,
                    },
                    token: token,
                })];
        });
    }); },
    deleteReport: function (token, uuid, deletionDate) { return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            url = "".concat(coreServiceUrl, "/reports/").concat(uuid);
            return [2 /*return*/, rest_1.default.delete({
                    mockFunc: function () { return ({ success: true, formerStatus: '', uuid: '1', jobId: '1' }); },
                    url: url,
                    body: {
                        jobDeleteAt: deletionDate,
                    },
                    token: token,
                })];
        });
    }); },
    updateReportViewed: function (token, uuid) { return __awaiter(void 0, void 0, void 0, function () {
        var url;
        return __generator(this, function (_a) {
            url = "".concat(coreServiceUrl, "/reports/view/").concat(uuid);
            return [2 /*return*/, rest_1.default.put({
                    mockFunc: function () { return ({ success: true, uuid: uuid }); },
                    url: url,
                    token: token,
                })];
        });
    }); },
    getReportStatus: function (token, jobId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return reportsApi_1.mockReportStatus; },
                    url: "".concat(coreServiceUrl, "/reports/status/").concat(jobId),
                    token: token,
                })];
        });
    }); },
    getCsvUrl: function (token, reportUuid, source) { return __awaiter(void 0, void 0, void 0, function () {
        var queryParams, params;
        return __generator(this, function (_a) {
            queryParams = new URLSearchParams(__assign(__assign({}, (reportUuid !== undefined && { reportUuid: reportUuid })), (source !== undefined && { source: source })));
            params = queryParams.toString();
            return [2 /*return*/, rest_1.default.get({
                    mockFunc: function () { return ({ success: true, signedUrl: 'https://www.s3-signed-url.com' }); },
                    url: "".concat(coreServiceUrl, "/reports/report-csv-url").concat(params ? "?".concat(params) : ''),
                    token: token,
                })];
        });
    }); },
    exportCsv: function (token, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () {
                        return { success: true, boolean: true, jobId: 1 };
                    },
                    url: "".concat(coreServiceUrl, "/activities/export-csv"),
                    body: options,
                    token: token,
                })];
        });
    }); },
    reExportCsv: function (token, uuid) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () {
                        return { success: true, boolean: true, jobId: 1 };
                    },
                    url: "".concat(coreServiceUrl, "/activities/re-export-csv/").concat(uuid),
                    token: token,
                })];
        });
    }); },
    undoDelete: function (token, uuid, status) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, rest_1.default.post({
                    mockFunc: function () {
                        return { success: true, boolean: true, jobId: 1 };
                    },
                    url: "".concat(coreServiceUrl, "/reports/undo-delete/").concat(uuid),
                    body: { status: status },
                    token: token,
                })];
        });
    }); },
};
exports.default = reportsApi;
